import { useAppDispatch, useAppSelector } from "../../Redux/app/hooks";
import { getPaymentsFormDetails, selectPayment } from "../../Redux/features/paymentSlice";
import CustomTable2 from "../CustomTable2";
import { PaymentsCols, paymentRows } from "./utils";

const AllPaymentsTable = () => {
  const { allPayments, gettingAllPayments } = useAppSelector(selectPayment);
  const dispatch = useAppDispatch();
  const rows = paymentRows(allPayments);

  const handlePagination = (value: number) => {
    dispatch(getPaymentsFormDetails({ name: "PageNumber", value }));
  };

  const handlePageLimit = (value: number) => {
    dispatch(getPaymentsFormDetails({ name: "PageSize", value }));
  };
  return (
    <CustomTable2
      data={{ rows, columns: PaymentsCols }}
      showPagination={true}
      showHeader={true}
      loading={gettingAllPayments}
      noRecord={allPayments?.records?.length === 0 || !allPayments}
      page={allPayments?.currentPage}
      pageCount={allPayments?.totalRecords}
      pageSize={allPayments?.pageSize}
      changeLimitHandler={handlePageLimit}
      changePagehandler={handlePagination}
    />
  );
};

export default AllPaymentsTable;
